const EligibleLayout = {
  Unset: 'Unset',
  Single: 'Single',
  Multi: 'Multi',
  SingleAndMulti: 'SingleAndMulti',
};

export {EligibleLayout};
